import React from "react";

export const textWithHighlighting = (text: string, highlight: string) => {
  // Escape special characters in the highlight, otherwise chracters like '\'
  // will throw an error.
  const escaped = highlight.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "gi"));

  return parts.map((part, i) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <strong key={i}>{part}</strong>
    ) : (
      <span key={i}>{part}</span>
    )
  );
};
